var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery_info"},[(_vm.text)?_c('div',{staticClass:"delivery_info_text",domProps:{"innerHTML":_vm._s(_vm.text)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }